"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OneToOneChat = OneToOneChat;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../../utils");
var _ChatPreview = require("../ChatPreview");
var _Channel = require("../Channel");
require("./OneToOneChat.less");
var _Messenger = require("../../../utils/Messenger");
var _ChatHeader = require("../ChatHeader");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function OneToOneChat(props) {
  var client = props.client,
    owner = props.owner,
    loading = props.loading,
    _props$activating = props.activating,
    activating = _props$activating === void 0 ? false : _props$activating,
    activeChannelId = props.activeChannelId,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'commerce light' : _props$theme,
    _props$filters = props.filters,
    filters = _props$filters === void 0 ? {
      type: _utils.MESSAGING_CHAT_CHANNEL_TYPE
    } : _props$filters,
    _props$sort = props.sort,
    sort = _props$sort === void 0 ? {
      last_message_at: -1
    } : _props$sort,
    _props$options = props.options,
    options = _props$options === void 0 ? {
      limit: 30
    } : _props$options,
    emptyMessageListText = props.emptyMessageListText,
    _props$messageActions = props.messageActions,
    messageActions = _props$messageActions === void 0 ? _utils.ALLOWED_MESSAGE_ACTIONS.PRIVATE : _props$messageActions,
    _props$editMessageInp = props.editMessageInputMaxRows,
    editMessageInputMaxRows = _props$editMessageInp === void 0 ? 1 : _props$editMessageInp,
    _props$inputGrow = props.inputGrow,
    inputGrow = _props$inputGrow === void 0 ? true : _props$inputGrow,
    _props$inputMaxRows = props.inputMaxRows,
    inputMaxRows = _props$inputMaxRows === void 0 ? 3 : _props$inputMaxRows,
    _props$onChannelListO = props.onChannelListOpened,
    onChannelListOpened = _props$onChannelListO === void 0 ? _utils.noop : _props$onChannelListO,
    previewUserId = props.previewUserId,
    _props$previewerCheck = props.previewerCheck,
    previewerCheck = _props$previewerCheck === void 0 ? false : _props$previewerCheck,
    _props$ChannelHeader = props.ChannelHeader,
    ChannelHeader = _props$ChannelHeader === void 0 ? _ChatHeader.ChatHeader : _props$ChannelHeader,
    _props$clinicianPatie = props.clinicianPatients,
    clinicianPatients = _props$clinicianPatie === void 0 ? {} : _props$clinicianPatie;
  var _useState = (0, _react.useState)((0, _utils.isFakeChannelId)(activeChannelId)),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuOpened = _useState2[0],
    setIsMenuOpened = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsMenuOpened((0, _utils.isFakeChannelId)(activeChannelId));
  }, [activeChannelId]);
  (0, _react.useEffect)(function () {
    if ((0, _utils.isMobileOrTablet)()) {
      setIsMenuOpened(true);
    }
  }, []);
  var sortChannels = (0, _Messenger.useChannelSortOptionsFromQueryString)(sort);
  var onSelect = function onSelect() {
    return setIsMenuOpened(false);
  };
  var Preview = (0, _react.useMemo)(function () {
    return function (props) {
      return /*#__PURE__*/_react.default.createElement(_ChatPreview.ChatPreview, _extends({
        client: client,
        owner: owner,
        onSelect: onSelect,
        previewUserId: previewUserId,
        clinicianPatients: clinicianPatients
      }, props));
    };
  }, [owner, client]);
  var handleChannelListOpenChange = function handleChannelListOpenChange() {
    var isOpened = !isMenuOpened;
    onChannelListOpened(isOpened);
    setIsMenuOpened(isOpened);
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading || activating
  }, !!client && /*#__PURE__*/_react.default.createElement("div", {
    className: "OneToOneChat PrivateChat"
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.Chat, {
    client: client,
    theme: theme
  }, !activating && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('channels-list', {
      'channel-list--open': isMenuOpened
    })
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.ChannelList, {
    client: client,
    customActiveChannel: activeChannelId,
    List: _streamChatReact.ChannelListMessenger,
    Preview: Preview,
    filters: filters,
    sort: sortChannels,
    options: options,
    channelRenderFilterFn: function channelRenderFilterFn(channels) {
      return channels.filter(function (_ref) {
        var type = _ref.type;
        return type === _utils.MESSAGING_CHAT_CHANNEL_TYPE;
      });
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('str-chat__wrapper', {
      'chat-menu-opened': isMenuOpened
    })
  }, /*#__PURE__*/_react.default.createElement(_Channel.Channel, {
    previewUserId: previewUserId,
    previewerCheck: previewerCheck,
    owner: owner,
    emptyMessageListText: emptyMessageListText,
    messageActions: messageActions,
    editMessageInputMaxRows: editMessageInputMaxRows,
    inputGrow: inputGrow,
    inputMaxRows: inputMaxRows,
    handleChannelListOpenChange: handleChannelListOpenChange,
    ChannelHeader: isMenuOpened && (0, _utils.isMobileOrTablet)() ? null : ChannelHeader,
    clinicianPatients: clinicianPatients
  })))));
}